<template>
    <v-app id="app">
        <component :is="layout">
            <router-view/>
        </component>
    </v-app>
</template>

<script>
    const defaultLayout = 'default';
    import { isProduction, loadScriptAsync } from '@/common/utils.js';

    export default {
        name: 'app',
        computed: {
            layout() {
                return `${ this.$route.meta.layout || defaultLayout }-layout`;
            }
        },
        methods: {
            attachFullStory() {
                if (!isProduction) {
                    return;
                }
                window['_fs_debug'] = false;
                window['_fs_host'] = 'fullstory.com';
                window['_fs_script'] = 'edge.fullstory.com/s/fs.js';
                window['_fs_org'] = 'WX68X';
                window['_fs_namespace'] = 'FS';
                (function(m,n,e,t,l,o,g,y){
                    if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');} return;}
                    g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];
                    o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://' + window['_fs_script'];
                    y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);
                    g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};
                    g.anonymize=function(){g.identify(!!0)};
                    g.shutdown=function(){g("rec",!1)};g.restart=function(){g("rec",!0)};
                    g.log = function(a,b){g("log",[a,b])};
                    g.consent=function(a){g("consent",!arguments.length||a)};
                    g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};
                    g.clearUserCookie=function(){};
                    g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];
                    if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};
                    g._v="1.2.0";
                })(window,document,window['_fs_namespace'],'script','user');
            },
        },
        created() {
            this.attachFullStory();
            loadScriptAsync('')
                .then(() => {
                    console.warn('IntersectionObserver polyfill loaded');
                })
                .catch(() => {
                    console.error('IntersectionObserver polyfill failed to load');
                });
        },
    }
</script>

<style lang="scss">
    html {
        height: 100%;
    }
    body {
        margin: 0;
        height: 100%;
        font-size: 1em;
    }
    #app {
        font-family: 'Roboto', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        font-size: 1em;
        height: 100%;
    }

    .el-card__header {
        h1, h2, h3, h4, h5, h6 {
            margin: 0;
        }
    }

    .el-select-dropdown__item, .el-dropdown-menu__item {
        font-family: 'Roboto', Helvetica, Arial, sans-serif;
    }

    .el-table__expand-column {
        background-color: #F5F7FA;
        .el-icon {
            font-size: 1.2em;
            font-weight: 900;
        }
    }

    .el-button.el-button--large {
        padding: 15px 30px;
        font-size: 1.5em;
        border-radius: 4px;
    }

    .el-card__header {
        h4 {
            font-size: 1.4em;
        }
        .el-button {
            font-size: 1.2em;
        }
    }

    .w-100 {
        width: 100%;
    }



    /// page header
    .el-page-header {
        padding: 10px 0;
        //box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);

        .el-page-header__content,
        .el-page-header__title {
            font-size: 1.2rem;
        }
    }
</style>
